import { render } from "./DashboardMedicos.vue?vue&type=template&id=1f3a15c0&scoped=true"
import script from "./DashboardMedicos.vue?vue&type=script&lang=js"
export * from "./DashboardMedicos.vue?vue&type=script&lang=js"

import "./DashboardMedicos.vue?vue&type=style&index=0&id=1f3a15c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3a15c0"]])

export default __exports__